// KYC resource statuses (documents, addresses, bank/crypto accounts).
// 'not_started' is the backend default for a freshly created resource — a
// record only exists once the user has submitted it, so it counts as
// submitted/awaiting review until a service or admin moves it along.
export const AWAITING_REVIEW_STATUSES = ['not_started', 'pending'];

export const SUBMITTED_STATUSES = [...AWAITING_REVIEW_STATUSES, 'verified'];

export const isAwaitingReview = status =>
  AWAITING_REVIEW_STATUSES.includes(status);

export const isSubmitted = status => SUBMITTED_STATUSES.includes(status);

// Human-readable fallback for raw enum values ('not_started' → 'not started').
export const humanizeStatus = status =>
  status ? String(status).replace(/_/g, ' ') : '';

// The platform *user's* status (rehive-core UserVerificationStatus). A different
// enum from the resource statuses above, and 'not_started' means the opposite
// here: nothing submitted yet.
//
// Both KYC services map their own review fields onto this, so never re-derive it
// from a provider's statuses. Bridge only writes it for groups it collects
// itself, so the two cannot fight over the field.
export const USER_VERIFICATION_STATUS = {
  NOT_STARTED: 'not_started',
  INCOMPLETE: 'incomplete',
  PENDING: 'pending',
  UNDER_REVIEW: 'under_review',
  PAUSED: 'paused',
  RESUBMISSION_REQUESTED: 'resubmission_requested',
  VERIFIED: 'verified',
  DECLINED: 'declined',
  OBSOLETE: 'obsolete',
  OFFBOARDED: 'offboarded',
};
